import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash-es';
import PowerAndSegmentGoalAchievements from './PowerAndSegmentGoalAchievements';
import FeaturedSegmentEffortAndBestEffortAchievements from './FeaturedSegmentEffortAndBestEffortAchievements';
import ActivityStats from './ActivityStats';
import AchievementCount from './AchievementCount';
import ActivityTextBody from './ActivityTextBody';
import CumulativeGoalAchievement from './CumulativeGoalAchievement';
import {
  powerAndSegmentGoalAchievementsProps,
  segAndBestEffortAchievementsProps,
  statsProps,
  cumulativeGoalAchievementProps
} from '../../../props/feed-prop-types';

import styles from './index.scss';

const ActivityEntryBody = ({
  activityName,
  activityId,
  ownedByCurrentAthlete,
  flagged,
  description,
  stats,
  segAndBestEffortAchievements,
  powerAndSegmentGoalAchievements,
  cumulativeGoalAchievement,
  activityType,
  athleteSex,
  athleteFirstName
}) => {
  return (
    <div
      className={styles.activityEntryContainer}
      data-testid="activity_entry_container"
    >
      {/* Header and Description */}
      <ActivityTextBody
        activityId={activityId}
        activityName={activityName}
        ownedByCurrentAthlete={ownedByCurrentAthlete}
        flagged={flagged}
        description={description}
      />

      {/* Activity Stats */}
      <div className={styles.media}>
        <div className={styles.mediaBody}>
          <ActivityStats stats={stats} />
        </div>

        {/* Segment Effort And Best Effort Achievements Count */}
        {segAndBestEffortAchievements.length > 0 && (
          <AchievementCount
            segAndBestEffortAchievements={segAndBestEffortAchievements}
            entityId={activityId}
          />
        )}
      </div>

      {/* Achievements Summary */}
      <ul
        className={styles.achievementsSummary}
        data-testid="achievement_summary"
      >
        {/* Power-Goal and Segment-Goal Achievements
        eg. 
          - Accomplished a goal of 9:00 on South Pearl Street << Segment-Goal
          - Accomplished a goal of 1W for 5 seconds (309 W) << Power-Goal
        */}
        {!isEmpty(powerAndSegmentGoalAchievements) && (
          <PowerAndSegmentGoalAchievements
            powerAndSegmentGoalAchievements={powerAndSegmentGoalAchievements}
            activityId={activityId}
          />
        )}

        {/* Cumulative Goal Achievement - (eg. Strava Athlete accomplished his swimming goal) */}
        {!isEmpty(cumulativeGoalAchievement) && (
          <CumulativeGoalAchievement
            cumulativeGoalAchievement={cumulativeGoalAchievement}
            activityType={activityType}
            athleteFirstName={athleteFirstName}
            athleteSex={athleteSex}
          />
        )}

        {/* Featured Segment Effort and Best Effort Achievements 
        eg. 
          - Bridge to Bridge N on Platte to Lee Gulch PR (4:08)
          - anti-clockwise loop around the lake CR (10:43)
        */}
        {!isEmpty(segAndBestEffortAchievements) && (
          <FeaturedSegmentEffortAndBestEffortAchievements
            segAndBestEffortAchievements={segAndBestEffortAchievements}
          />
        )}
      </ul>
    </div>
  );
};

ActivityEntryBody.propTypes = {
  activityId: PropTypes.string.isRequired,
  activityName: PropTypes.string.isRequired,
  ownedByCurrentAthlete: PropTypes.bool,
  flagged: PropTypes.bool,
  description: PropTypes.string,
  anchor_container_click_data: PropTypes.shape({
    self: PropTypes.string
  }),
  stats: statsProps,
  segAndBestEffortAchievements: segAndBestEffortAchievementsProps,
  powerAndSegmentGoalAchievements: powerAndSegmentGoalAchievementsProps,
  cumulativeGoalAchievement: cumulativeGoalAchievementProps,
  activityType: PropTypes.string.isRequired,
  athleteSex: PropTypes.string,
  athleteFirstName: PropTypes.string
};

ActivityEntryBody.defaultProps = {
  ownedByCurrentAthlete: false,
  flagged: false,
  description: '',
  anchor_container_click_data: {},
  stats: [],
  segAndBestEffortAchievements: [],
  powerAndSegmentGoalAchievements: [],
  cumulativeGoalAchievement: {},
  athleteSex: '',
  athleteFirstName: ''
};

export default ActivityEntryBody;
